var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2698 45.7423L39.5276 36.001L49.2698 26.2577C49.7355 25.7882 49.9968 25.1537 49.9968 24.4924C49.9968 23.8311 49.7355 23.1965 49.2698 22.727C48.8004 22.2613 48.1659 22 47.5047 22C46.8434 22 46.209 22.2613 45.7395 22.727L35.9974 32.4703L26.2572 22.727C25.7878 22.2613 25.1533 22 24.4921 22C23.8309 22 23.1964 22.2613 22.727 22.727C22.2613 23.1965 22 23.8311 22 24.4924C22 25.1537 22.2613 25.7882 22.727 26.2577L32.4671 36.001L22.727 45.7423C22.2613 46.2118 22 46.8463 22 47.5076C22 48.1689 22.2613 48.8035 22.727 49.273C23.1964 49.7387 23.8309 50 24.4921 50C25.1533 50 25.7878 49.7387 26.2572 49.273L35.9974 39.5316L45.7395 49.273C46.209 49.7387 46.8434 50 47.5047 50C48.1659 50 48.8004 49.7387 49.2698 49.273C49.7374 48.8045 50 48.1696 50 47.5076C50 46.8457 49.7374 46.2108 49.2698 45.7423Z",
    fill: "#929AAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.841ddd0f71ed2ea9347e365af06c89d3.svg";
export { ForwardRef as ReactComponent };